export enum AccessTokenMethod {
  publicLink = 'publicLink',
  privateLink = 'privateLink',
  email = 'email',
  coBrowsing = 'co-browsing',
}
